import React, { forwardRef } from "react";
import {
  calculateAgeString,
  calculateTaxes,
  formatDate,
} from "../../_helper/utils/utils";

// Helper function to format expiry date as "MM/YY"
const formatExpiry = (dateStr) => {
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr;
  const month = date.getMonth() + 1;
  const year = date.getFullYear() % 100;
  return `${month < 10 ? "0" + month : month}/${year < 10 ? "0" + year : year}`;
};

const PharmacyBillPrint = forwardRef(({ billData }, ref) => {
  // console.log("Bill Data", billData);
  return (
    <div
      ref={ref}
      style={{ width: "105mm", minHeight: "148mm" }}
      className="mx-auto font-sans text-xs bg-white p-2"
    >
      {/* Header */}
      <div className="text-center pb-2 border-b border-gray-400">
        <h2 className="text-base font-bold text-gray-800 uppercase">
          {billData?.pharmacy_id?.pharmacy_name}
        </h2>
        <p className="leading-tight text-gray-600">
          {billData?.pharmacy_id?.address}, {billData?.pharmacy_id?.city},{" "}
          {billData?.pharmacy_id?.state}
        </p>
        <p className="leading-tight text-gray-600">
          Mob: {billData?.pharmacy_id?.pharmacy_contact_number}{" "}
          {billData?.pharmacy_id?.gstin_number &&
            `| GSTIN: ${billData?.pharmacy_id?.gstin_number}`}
        </p>
      </div>

      {/* Invoice & Patient Details */}
      <div className="py-1 border-b border-gray-400">
        <div className="grid grid-cols-2  text-xs leading-tight">
          <p className="text-gray-700 text-xs">
            <strong>Date:</strong> {formatDate(billData?.date)}
          </p>
          <p className="text-gray-700 text-xs">
            <strong>Patient:</strong> {billData?.patient_id?.full_name}
          </p>
          <p className="text-gray-700 text-xs">
            <strong>Age:</strong>{" "}
            {calculateAgeString(billData?.patient_id?.dob)}
          </p>
          <p className="text-gray-700 text-xs">
            <strong>Gender:</strong> {billData?.patient_id?.gender}
          </p>
          <p className="text-gray-700 col-span-2 text-xs">
            <strong>Doctor:</strong> {billData?.doctor?.doctor_name || "N/A"}
          </p>
        </div>
      </div>

      {/* Items Table */}
      <div className="py-2">
        <table className="w-full table-fixed border-collapse">
          <thead>
            <tr className="bg-gray-100">
              <th className="border px-1 py-1 text-center">Qty</th>
              <th className="border px-1 py-1 text-center">Product</th>
              <th className="border px-1 py-1 text-center">Batch</th>
              <th className="border px-1 py-1 text-center">Exp</th>
              <th className="border px-1 py-1 text-center">Amt</th>
            </tr>
          </thead>
          <tbody>
            {billData?.billing_item?.map((itm, index) => {
              const { totalAmount } = calculateTaxes(itm);
              return (
                <tr key={index}>
                  <td className="border px-1 py-1 text-center">
                    {itm.quantity || "-"}
                  </td>
                  <td className="border px-1 py-1 text-center">
                    {itm.items_name || "-"}
                  </td>
                  <td className="border px-1 py-1 text-center">
                    {itm.batch_no || "-"}
                  </td>
                  <td className="border px-1 py-1 text-center">
                    {formatExpiry(itm.expiry_date) || "-"}
                  </td>
                  <td className="border px-1 py-1 text-center">
                    ₹{totalAmount?.toFixed(2)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Totals */}
      <div className="border-t border-gray-400 pt-1">
        <div className="space-y-1">
          <div className="flex justify-between text-xs">
            <strong>Subtotal:</strong>
            <span>₹{billData?.payment_summary?.subtotal?.toFixed(2)}</span>
          </div>
          <div className="flex justify-between text-xs">
            <strong>CGST:</strong>
            <span>
              ₹{billData?.payment_summary?.totalTaxes?.cgst?.toFixed(2)}
            </span>
          </div>
          <div className="flex justify-between text-xs">
            <strong>SGST:</strong>
            <span>
              ₹{billData?.payment_summary?.totalTaxes?.sgst?.toFixed(2)}
            </span>
          </div>
          <div className="flex justify-between text-xs">
            <strong>IGST:</strong>
            <span>
              ₹{billData?.payment_summary?.totalTaxes?.igst?.toFixed(2)}
            </span>
          </div>
          <div className="flex justify-between text-xs font-bold text-gray-800">
            <strong>Grand Total:</strong>
            <span>₹{billData?.payment_summary?.grandTotal?.toFixed(2)}</span>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="text-center text-gray-600 border-t border-gray-400 pt-2">
        <p className="leading-tight">
          E &amp; O.E. Subject to PMC Jurisdiction
        </p>
        <p className="leading-tight">
          DLN: {billData?.pharmacy_id?.license_no}
        </p>
        <p className="leading-tight font-semibold mt-1">** Thank You! **</p>
        <p className="leading-tight">Pharmacist/Sig.</p>
      </div>
    </div>
  );
});

export default PharmacyBillPrint;
